<template>
  <div>
    <div v-if="!isHideSelect" class="video-player__bar">
      <div class="button-back">
        <button @click="goBack()">
          <Back />
        </button>
      </div>
      <div class="button-log" v-show="showRefreshButton">
        <button @click="refresh">
          <Refresh />
        </button>
      </div>
      <div v-if="isSelect && !isHideSelect" class="video-player__select">
        <select class="video-player__select-season" @change="changeSeason" v-model="selectedSeason">
          <option value="" label="Seasons" disabled aria-disabled="true" />
          <option v-for="season in seasons" :key="season" :value="season" :label="`Season ${season}`" />
        </select>
        <select class="video-player__select-season" @change="changeEpisode" v-model="selectedEpisode">
          <option value="" label="Episodes" disabled aria-disabled="true" />
          <option v-for="episode in episodes" :key="episode" :value="episode" :label="`Episode ${episode}`" />
        </select>
      </div>
    </div>
    <div class="video-player__wrap" v-if="isMkv()">
      <PlayerMkv
        :linkVideo="videoSrc"
        :textTrack="textTracks"
        :startTime="historyMoviesStartTime"
        @playing="onVideoPlaying"
        @pause="onVideoPause"
        @timeupdate="onVideoTimeUpdate"
        @waiting="onVideoWaiting"
        @stalled="onVideoStalled"
        @error="onVideoError"
      />
    </div>
    <div class="video-player__wrap" v-else>
      <VideoPlayer
        @playing="onVideoPlaying"
        @pause="onVideoPause"
        :startTime="historyMoviesStartTime"
        @timeupdate="onVideoTimeUpdate"
        :linkVideo="videoSrc"
        :textTracks="textTracks"
        @waiting="onVideoWaiting"
        @stalled="onVideoStalled"
        @error="onVideoError"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Back from '@/assets/icons/svg/back.svg';
import PlayerMkv from '@/views/Player/PlayerMkv';
import VideoPlayer from '@/views/Player/VideoPlayer';
import { getItem, getItem as getLocalstorageItem, removeItem, setItem } from '@/helpers/storage';
import Refresh from '@/assets/icons/svg/refresh.svg';

export default {
  name: 'PlayerWrap',
  data() {
    return {
      player: null,
      isSelect: false,
      isHideSelect: false,
      videoSrc: '',
      episodes: [],
      seasons: [],
      selectedEpisode: 1,
      selectedSeason: 1,
      trackId: '',
      timer: null,
      starPlaying: null,
      historyTime: 0,
      currentTime: 0,
      contentInfo: null,
      showRefreshButton: true,
      leadId: undefined,
      guid: undefined,
    };
  },
  components: {
    PlayerMkv,
    VideoPlayer,
    Back,
    Refresh,
  },
  methods: {
    async goBack() {
      await this.sendWatchTime();
      this.$router.go(-1);
    },
    getItem() {
      if (this.linkVideo) {
        return;
      }
      const contentInfo = getLocalstorageItem('content-info');
      const { trackId, type, season, episode } = contentInfo;

      if (!trackId || !type) {
        this.$router.push('/');
        return;
      }

      this.trackId = trackId;
      this.fetchWatchHistory();

      if (type === 'getLinkSportVod') {
        this.$store.dispatch('getLinkSportVod', { id: trackId });
      }
      if (type === 'getLinkLive') {
        this.$store.dispatch('getLinkLive', { id: `${trackId}.m3u8` });
      }
      if (type === 'getLinkMovie') {
        this.$store.dispatch('getLinkMovie', { id: trackId });
      }
      if (type === 'getLinkTvShow') {
        this.$store.dispatch('getLinkTvShow', {
          id: trackId,
          season: season,
          episode: episode,
        });
        this.isSelect = true;
      }
    },
    isMkv() {
      return this.videoSrc?.indexOf('.mkv') !== -1;
    },
    changeSeason(e) {
      const contentInfo = getLocalstorageItem('content-info');

      setItem('content-info', {
        ...contentInfo,
        season: e.target.value,
      });

      this.selectedSeason = e.target.value;
    },
    changeEpisode(e) {
      const contentInfo = getLocalstorageItem('content-info');

      setItem('content-info', {
        ...contentInfo,
        episode: e.target.value,
      });

      this.selectedEpisode = e.target.value;
      this.$store.dispatch('getLinkTvShow', {
        id: this.trackId,
        season: this.selectedSeason,
        episode: this.selectedEpisode,
      });
    },
    onVideoPlaying() {
      this.isHideSelect = true;
      this.showRefreshButton = false;

      if (!this.timer) {
        this.timer = setInterval(() => {
          this.sendWatchTime();
        }, 10 * 60 * 1000);
      }
    },
    onVideoPause() {
      this.isHideSelect = false;
      this.starPlaying = null;
      this.showRefreshButton = true;

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleBeforeUnload() {
      const { type, episode, season } = this.contentInfo;
      const seconds = this.currentTime;
      const id = this.trackId;

      setItem('usaved-data', { type, id, episode, season, seconds });
    },
    onVideoTimeUpdate(currentSec) {
      if (!isNaN(currentSec)) {
        this.currentTime = currentSec;
      }
    },
    async sendWatchTime() {
      const { type, episode, season } = this.contentInfo;
      const seconds = this.currentTime;
      const id = this.trackId;

      await this.$store.dispatch('updateHistoryTime', { type, id, episode, season, seconds, leadId: this.leadId, guid: this.guid });
    },

    async fetchWatchHistory() {
      this.contentInfo = getLocalstorageItem('content-info');
      const id = this.trackId;
      const type = this.contentInfo.type;

      if (!id) return;

      await this.$store.dispatch('getHistoryTime', { type, id });
    },
    async refresh() {
      if (this.currentTime > this.historyMoviesStartTime) {
        await this.sendWatchTime();
      }

      this.getItem();
    },
    onVideoWaiting() {
      this.showRefreshButton = true;
    },
    onVideoStalled() {
      this.showRefreshButton = true;
    },
    onVideoError() {
      this.showRefreshButton = true;
    },
  },
  computed: {
    ...mapState({
      linkVideoState: (state) => state.playVideo.linkPlay,
      textTracks: (state) => state.playVideo.subtitles,
      infoTvShow: (state) => state.playVideo.infoTvShow,
      historyMoviesStartTime: (state) => state.playVideo.historyStartTime,
    }),
    ...mapGetters({ isTrial: 'isTrial', leadId: 'leadId' }),
  },
  watch: {
    linkVideoState() {
      this.videoSrc = this.linkVideoState?.secure_link;
    },
    subtitles() {
      this.textTrack = this.subtitles?.data;
    },
    infoTvShow() {
      const seasonsList = this.infoTvShow?.[0].meta_episodes || [];
      const episodesList = seasonsList?.[this.selectedSeason - 1] || [];
      this.seasons = seasonsList.map((_, index) => index + 1);
      this.episodes = episodesList.map((item) => item.episode);
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    const guideUserCred = getItem('guidCredentials');
    this.leadId = guideUserCred?.lead;
    this.guid = guideUserCred?.guid;
  },
  async beforeMount() {
    const unsavedData = getLocalstorageItem('usaved-data');

    if (unsavedData) {
      const { type, id, seconds, episode, season } = unsavedData;

      await this.$store.dispatch('updateHistoryTime', { type, id, episode, season, seconds, leadId: this.leadId, guid: this.guid });

      removeItem('usaved-data');
    }

    this.getItem();
  },
  beforeUnmount() {
    this.sendWatchTime();
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
};
</script>
<style lang="scss" scoped>
.video-player {
  &__wrap {
    height: 100vh;
  }

  &__bar {
    display: flex;
    position: absolute;
    top: 20px;
    z-index: 100;
    left: 30px;
  }

  &__select {
    display: flex;
    position: absolute;
    top: 20px;
    left: 40px;

    &-episode {
      width: 100px !important;
      border-radius: 2px;
      margin-left: 10px;
    }

    &-season {
      width: 200px;
      border-radius: 2px;
      background: transparent;
      border-color: #fff;
      color: #fff;
      margin-right: 10px;
      min-height: 40px;
      padding: 0 10px;
    }
  }
}

.button-back {
  position: absolute;
  top: 9px;
  left: -30px;

  svg {
    padding-top: 5px;
    fill: white;
    width: 30px;
    margin-right: 20px;
  }

  button {
    cursor: pointer;
    padding: 12px 24px;
    background: transparent;
    outline: 0;
    border: 0;
  }
}

.video-player__select-season option {
  color: black;
}

.button-log {
  position: absolute;
  top: 9px;
  left: 62px;

  svg {
    fill: white;
    margin: 5px 20px 0px 0px;
  }

  button {
    cursor: pointer;
    background: transparent;
    outline: 0;
    border: 0;
    width: 98px;
    height: 62px;
  }
}
</style>
